import React from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Row,
  Tab,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  tambahAreaManager,
  getAllAreaManager,
  getAllClient,
  getAllCabang,
} from "stores";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { penempatanAreaManager } from "stores";
import { editStatusAreaManager } from "stores";
import { resetPassword } from "stores";
import { Dna } from "react-loader-spinner";
import { settingMenuAM } from "stores";

function ListAreaManager() {
  const dispatch = useDispatch();
  const storeClient = useSelector((state) => state.clientReducer);
  const storeCabang = useSelector((state) => state.cabangReducer);
  const areaManager = useSelector((state) => state.areaManagerReducer);
  const auth = useSelector((state) => state.authReducer);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const [modalAreaManager, setModalAreaManager] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [modalUbahPenempatan, setModalUbahPenempatan] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [pilihClient, setPilihClient] = React.useState(null);
  const [pilihCabang, setPilihCabang] = React.useState(null);
  const [nik, setNik] = React.useState("");
  const [nama, setNama] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [listAreaManager, setListAreaManager] = React.useState([]);
  const [listClient, setListClient] = React.useState([]);
  const [listCabang, setListCabang] = React.useState([]);
  const [idClientAM, setIdClientAM] = React.useState("");
  const [idCabang, setIdCabang] = React.useState(null);
  const [idAreaManager, setIdAreaManager] = React.useState("");
  const [listDetailCabang, setListDetailCabang] = React.useState([]);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [status, setStatus] = React.useState("");
  const [searchText, setSearchText] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(true);
  const [modalSettingMenu, setModalSettingMenu] = React.useState(false);
  const [multipleSelect, setMultipleSelect] = React.useState([]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleNikChange = (e) => {
    const inputNik = e.target.value;
    const formattedNik = inputNik.slice(0, 16);
    setNik(formattedNik);
  };

  const remainingDigits = 16 - nik.length;

  const submitSettingMenu = () => {
    const dataToSend = {
      idAreaManager: idAreaManager,
      menu: multipleSelect.map((option) => option.value),
    };
    settingMenuAM(dataToSend)
      .then((response) => {
        if (response.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllAreaManager(dispatch, { idClient: "" });
          setModalSettingMenu(false);
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitAreaManager = () => {
    if (nik.length < 16) {
      Swal.fire({
        title: "NIK harus 16 digit !!",
        icon: "warning",
      });
      return;
    }
    tambahAreaManager({
      nik: nik,
      nama: nama,
      nopeg: nopeg,
      idClient: idClientAM,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          getAllAreaManager(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    // console.log(status.value);
    editStatusAreaManager({
      idAreaManager: idAreaManager,
      status: status.value,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllAreaManager(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitPenempatan = () => {
    if (pilihCabang === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Cabang tidak boleh kosong",
      });
    } else {
      penempatanAreaManager({
        idAreaManager: idAreaManager,
        idCabang: idCabang,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          // setIdCabang("");
          // setPilihCabang("");
          getAllAreaManager(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const handleModalClose = () => {
    setPilihCabang(null);
    setIdCabang(null);
    setPilihClient(null);
    setModalAreaManager(false);
    setModalPenempatan(false);
    setIdClientAM("");
    setPilihClient("");
    setNik("");
    setNopeg("");
    setNama("");
  };

  React.useEffect(() => {
    let tmp =
      areaManager.listAreaManager &&
      areaManager.listAreaManager.map((val) => {
        return {
          ...val,
          action: (
            <div
              className="d-flex align-items-center flex-wrap"
              style={{ gap: "8px" }}
            >
              {auth.role === "super admin" || auth.role === "admin" ? (
                <>
                  {/* TOMBOL PENEMPATAN */}
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Penempatan AM</Tooltip>}
                  >
                    <Button
                      disabled={val.status !== "aktif"}
                      className="d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "none",
                        backgroundColor:
                          val.status === "tidak aktif" ? "#cbd5e1" : "#447DF7",
                        transition: "0.2s",
                      }}
                      onClick={() => {
                        setIdAreaManager(val._id);
                        getAllCabang(dispatch, { idClient: val.idClient });
                        setModalPenempatan(!modalPenempatan);
                      }}
                    >
                      <i className="fas fa-map-marked-alt"></i>
                    </Button>
                  </OverlayTrigger>

                  {/* TOMBOL EDIT STATUS */}
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Edit Status</Tooltip>}
                  >
                    <Button
                      className="d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "none",
                        backgroundColor: "#10b981",
                      }}
                      onClick={() => {
                        setIdAreaManager(val._id);
                        setModalEdit(!modalEdit);
                      }}
                    >
                      <i className="fas fa-edit"></i>
                    </Button>
                  </OverlayTrigger>

                  {/* TOMBOL RESET PASSWORD */}
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Reset Password</Tooltip>}
                  >
                    <Button
                      className="d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "none",
                        backgroundColor: "#f90203",
                      }}
                      onClick={async () => {
                        const result = await Swal.fire({
                          title: "Reset Password",
                          text: `Reset password untuk ${val.nama}?`,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#2e3192",
                          cancelButtonText: "Batal",
                        });
                        if (result.isConfirmed) {
                          try {
                            const response = await resetPassword({
                              idUser: val._id,
                              role: val.role,
                            });
                            Swal.fire(
                              "Sukses",
                              response.data.message,
                              "success",
                            );
                          } catch (error) {
                            Swal.fire("Error", "Gagal reset password", "error");
                          }
                        }
                      }}
                    >
                      <i className="fas fa-redo-alt"></i>
                    </Button>
                  </OverlayTrigger>
                </>
              ) : (
                "-"
              )}

              {auth.role === "super admin" && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Setting Menu</Tooltip>}
                >
                  <Button
                    className="d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "38px",
                      height: "38px",
                      borderRadius: "10px",
                      border: "none",
                      backgroundColor: "#2e3192",
                    }}
                    onClick={() => {
                      setModalSettingMenu(!modalSettingMenu);
                      setIdAreaManager(val._id);
                    }}
                  >
                    <i className="fas fa-user-cog"></i>
                  </Button>
                </OverlayTrigger>
              )}
            </div>
          ),
        };
      });
    setListAreaManager(tmp);
  }, [
    areaManager.listAreaManager,
    auth,
    modalEdit,
    modalPenempatan,
    modalSettingMenu,
  ]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeCabang.listCabang &&
      storeCabang.listCabang.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaCabang,
        });
      });
    setListCabang(tmp);
  }, [storeCabang.listCabang]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });
    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f1f5f9", // Abu-abu biru khas UI modern
        minHeight: "55px",
        borderTop: "1px solid #e2e8f0",
        borderBottom: "2px solid #e2e8f0",
      },
    },
    headCells: {
      style: {
        fontSize: "13px",
        fontWeight: "800",
        textTransform: "uppercase",
        color: "#475569",
        justifyContent: "flex-start", // Paksa rata kiri
        paddingLeft: "20px",
      },
    },
    rows: {
      style: {
        minHeight: "75px",
        "&:not(:last-of-type)": {
          borderBottom: "1px solid #f1f5f9",
        },
        "&:hover": {
          backgroundColor: "#f8fafc",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        justifyContent: "flex-start", // Paksa rata kiri
        paddingLeft: "20px",
      },
    },
  };

  const colAreaManager = [
    {
      name: "NO",
      width: "70px",
      cell: (row, index) => (
        <span className="fw-800 text-muted">
          {(currentPage - 1) * itemsPerPage + index + 1}
        </span>
      ),
    },
    {
      name: "AREA MANAGER",
      minWidth: "280px",
      center: false,
      cell: (row) => (
        <div className="d-flex align-items-center ml-1 py-2">
          {/* Avatar Inisial (Biru Jatim) */}
          <div
            className="mr-3 d-flex align-items-center justify-content-center rounded-lg shadow-sm"
            style={{
              width: "42px",
              height: "42px",
              background: "linear-gradient(135deg, #2e3192 0%, #1e293b 100%)",
              color: "white",
              fontSize: "16px",
              fontWeight: "900",
            }}
          >
            {row.nama.charAt(0).toUpperCase()}
          </div>
          <div>
            <span
              className="fw-900 text-dark d-block"
              style={{ fontSize: "16px", lineHeight: "1.2" }}
            >
              {row.nama}
            </span>
            <span className="text-muted fw-700" style={{ fontSize: "12px" }}>
              ID: {row.kodeUser} | {row.nopeg}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "BPD",
      minWidth: "150px",
      omit: auth.role !== "super admin",
      selector: (row) => row.namaClient[0],
    },
    {
      name: "Cabang Penempatan",
      minWidth: "250px",
      cell: (row) => {
        // Jika tidak ada penempatan
        if (
          row.penempatan.length === 0 ||
          (row.penempatan.length === 1 && !row.penempatan[0].namaCabang)
        ) {
          return (
            <div
              className="d-flex align-items-center text-muted"
              style={{ fontStyle: "italic", fontSize: "13px" }}
            >
              <i className="fas fa-minus-circle mr-2 opacity-50"></i> Belum ada
              penempatan
            </div>
          );
        }

        // Jika ada penempatan
        return (
          <div className="py-2">
            {/* Nama Cabang Utama */}
            <div className="d-flex align-items-center mb-1">
              <i
                className="fas fa-map-marker-alt text-danger mr-2"
                style={{ fontSize: "12px" }}
              ></i>
              <span
                style={{
                  fontWeight: "700",
                  color: "#2D3748",
                  fontSize: "14px",
                }}
              >
                {row.penempatan[0].namaCabang}
              </span>
            </div>

            {/* Indikator Cabang Lainnya (Tanpa Blok Warna) */}
            {row.penempatan.length > 1 && (
              <div
                className="d-flex align-items-center mt-1"
                style={{
                  cursor: "pointer",
                  fontSize: "12px",
                  color: "#4E73DF",
                  paddingLeft: "20px", // Agar sejajar di bawah teks nama cabang
                }}
                onClick={() => {
                  setListDetailCabang(row);
                  setModalDetail(true);
                }}
              >
                <span
                  style={{
                    borderBottom: "1px dashed #4E73DF",
                    fontWeight: "600",
                  }}
                >
                  <i
                    className="fas fa-external-link-alt mr-1"
                    style={{ fontSize: "10px" }}
                  ></i>
                  Lihat {row.penempatan.length - 1} cabang lainnya
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      name: "Status",
      minWidth: "140px",
      center: true,
      cell: (row) => {
        const isActive = row.status === "aktif";
        return (
          <span
            style={{
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "bold",
              backgroundColor: isActive ? "#D1FAE5" : "#FEE2E2",
              color: isActive ? "#065F46" : "#991B1B",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#10B981" : "#EF4444",
                marginRight: "8px",
              }}
            ></span>
            {isActive ? "Aktif" : "Tidak Aktif"}
          </span>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "150px",
      center: true,
      omit: !(auth.role === "super admin" || auth.role === "admin"),
      cell: (row) => row.action, // Pastikan row.action merender button aksi Anda
    },
  ];

  React.useEffect(() => {
    getAllAreaManager(dispatch, { idClient: "" })
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
    getAllClient(dispatch);
  }, []);

  return (
    <>
      <Modal
        size="md"
        show={modalSettingMenu}
        onHide={() => setModalSettingMenu(!modalSettingMenu)}
        centered
        contentClassName="border-0 shadow-lg"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <div className="text-center mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{
                width: "60px",
                height: "60px",
                backgroundColor: "#f1f5f9",
                borderRadius: "15px",
                color: "#2e3192",
              }}
            >
              <i
                className="fas fa-tasks fa-2x"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h4 className="font-weight-bold m-0">SETTING MENU AM</h4>
            <p className="text-muted small">
              Kelola akses menu khusus Area Manager
            </p>
          </div>
          <Form.Group>
            <label className="small fw-800 text-muted text-uppercase mb-2">
              Daftar Menu Tersedia
            </label>
            <Select
              isMulti
              classNamePrefix="react-select"
              placeholder="Cari & Pilih Menu..."
              value={multipleSelect}
              onChange={(v) => setMultipleSelect(v)}
              options={[
                { value: "Dashboard", label: "Dashboard" },
                { value: "Client", label: "Client" },
                { value: "User", label: "User" },
                { value: "Cabang", label: "Cabang" },
                { value: "Target", label: "Target" },
                { value: "Pengajuan", label: "Pengajuan" },
                { value: "Pencairan", label: "Pencairan" },
                { value: "Kunjungan", label: "Kunjungan" },
              ]}
              styles={{
                control: (b) => ({
                  ...b,
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0",
                }),
              }}
            />
          </Form.Group>
          <Button
            className="btn-block py-3 mt-4 border-0 shadow-sm fw-900"
            style={{
              background: "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
              borderRadius: "12px",
              color: "white",
            }}
            onClick={submitSettingMenu}
          >
            SIMPAN AKSES MENU
          </Button>
        </Modal.Body>
      </Modal>

      {/* MODAL EDIT STATUS AM */}
      <Modal
        size="sm"
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(!modalEdit);
        }}
        centered
        contentClassName="border-0 shadow-lg"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-4 pb-4 text-center">
          <div className="mb-3 text-primary">
            <i className="fas fa-user-cog fa-3x"></i>
          </div>
          <h4 className="font-weight-bold mb-1">EDIT STATUS</h4>
          <p className="text-muted small mb-4">
            Ubah keaktifan akun Area Manager
          </p>
          <Select
            classNamePrefix="react-select"
            value={status}
            onChange={(v) => setStatus(v)}
            options={[
              { value: "true", label: "✅ AKTIF" },
              { value: "false", label: "❌ TIDAK AKTIF" },
            ]}
            styles={{ control: (b) => ({ ...b, borderRadius: "10px" }) }}
          />
          <Button
            className="btn-block py-3 mt-4 border-0 fw-900 shadow-sm"
            style={{
              background: "#2e3192",
              borderRadius: "12px",
              color: "white",
            }}
            onClick={checkStatus}
          >
            UPDATE STATUS
          </Button>
        </Modal.Body>
      </Modal>

      {/* MODAL PENEMPATAN / UBAH PENEMPATAN */}
      <Modal
        size="md"
        show={modalPenempatan || modalUbahPenempatan}
        onHide={() => {
          handleModalClose();
          setModalPenempatan(false);
          setModalUbahPenempatan(false);
        }}
        centered
        contentClassName="border-0 shadow-lg"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <div className="text-center mb-4">
            <div
              className="p-3 d-inline-block mb-3"
              style={{
                background: "#f0f9ff",
                borderRadius: "15px",
                color: "#0ea5e9",
              }}
            >
              <i
                className="fas fa-map-location-dot fa-2x"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h4 className="font-weight-bold m-0">
              {modalUbahPenempatan ? "UBAH PENEMPATAN" : "FORM PENEMPATAN"} AM
            </h4>
            <p className="text-muted small">
              Tentukan cabang yang akan dikelola Area Manager
            </p>
          </div>
          <Form.Group>
            <label className="small fw-800 text-muted text-uppercase mb-2">
              Pilih Cabang / BPD
            </label>
            <Select
              classNamePrefix="react-select"
              value={pilihCabang}
              onChange={(v) => {
                setPilihCabang(v);
                setIdCabang(v.value);
              }}
              options={listCabang}
              placeholder="Cari Nama Cabang..."
              styles={{ control: (b) => ({ ...b, borderRadius: "12px" }) }}
            />
          </Form.Group>
          <Button
            className="btn-block py-3 mt-4 border-0 fw-900 shadow-sm"
            style={{
              background: "#2e3192",
              borderRadius: "12px",
              color: "white",
            }}
            onClick={modalUbahPenempatan ? undefined : submitPenempatan}
          >
            SIMPAN PENEMPATAN
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalDetail}
        onHide={() => setModalDetail(!modalDetail)}
        centered
        scrollable
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex", // Pakai flex biasa
                alignItems: "center", // Center vertikal
                justifyContent: "center", // Center horizontal
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginRight: "auto", // Gabungan auto kiri-kanan
                marginLeft: "auto", // biar container birunya di tengah modal
              }}
            >
              <i
                className="fas fa-info-circle fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>

            <h3 className="fw-800 text-dark mb-1">Detail Penempatan</h3>
            <p className="text-muted">
              Informasi jangkauan wilayah Area Manager
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              {/* INFO PROFIL */}
              <div className="mb-4 pb-3 border-bottom">
                <Row className="mb-2">
                  <Col xs="5" sm="4" className="text-muted fw-bold small">
                    NAMA LENGKAP
                  </Col>
                  <Col xs="7" sm="8" className="text-dark fw-bold">
                    : {listDetailCabang.nama}
                  </Col>
                </Row>
                <Row className="mb-0">
                  <Col xs="5" sm="4" className="text-muted fw-bold small">
                    JABATAN
                  </Col>
                  <Col xs="7" sm="8" className="text-dark fw-bold">
                    : Area Manager
                  </Col>
                </Row>
              </div>

              {/* LIST CABANG DENGAN TOTAL */}
              <div className="bg-light p-3" style={{ borderRadius: "15px" }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="fw-bold text-primary m-0">
                    <i className="fas fa-map-marked-alt mr-2"></i>Daftar Cabang
                  </h6>
                  {/* BADGE TOTAL CABANG */}
                  <span
                    className="badge bg-white text-primary shadow-sm px-3 py-2"
                    style={{
                      borderRadius: "10px",
                      fontSize: "12px",
                      border: "1px solid #4E73DF",
                    }}
                  >
                    Total:{" "}
                    <span className="fw-800">
                      {listDetailCabang.penempatan?.length || 0}
                    </span>{" "}
                    Cabang
                  </span>
                </div>

                <div
                  style={{
                    maxHeight: "30vh",
                    overflowY: "auto",
                    paddingRight: "5px",
                  }}
                >
                  <ul className="list-group list-group-flush bg-transparent">
                    {listDetailCabang.penempatan &&
                    listDetailCabang.penempatan.length > 0 ? (
                      listDetailCabang.penempatan.map((val, index) => (
                        <li
                          key={index}
                          className="list-group-item bg-transparent border-0 py-2 ps-0 text-dark fw-600 d-flex align-items-center"
                        >
                          <div
                            className="bg-success rounded-circle mr-3 d-flex align-items-center justify-content-center"
                            style={{
                              width: "22px",
                              height: "22px",
                              minWidth: "22px",
                            }}
                          >
                            <i
                              className="fas fa-check text-white"
                              style={{ fontSize: "10px" }}
                            ></i>
                          </div>
                          {val.namaCabang}
                        </li>
                      ))
                    ) : (
                      <li className="list-group-item bg-transparent border-0 text-muted italic">
                        Belum ada cabang terdaftar.
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="sm" // Ukuran kecil biar fokus dan elegan
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(!modalEdit);
        }}
        centered
        contentClassName="border-0 shadow-lg"
        style={{ backdropFilter: "blur(5px)" }} // Efek blur background biar fokus
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-4 pb-4 text-center">
          {/* Ikon Indikator */}
          <div className="mb-3">
            <div
              className="d-inline-flex align-items-center justify-content-center"
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#f1f5f9",
                borderRadius: "50%",
                color: "#2e3192",
              }}
            >
              <i
                className="fas fa-user-shield fa-2x"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
          </div>

          <h4 className="font-weight-bold mb-1" style={{ color: "#1e293b" }}>
            UPDATE STATUS AM
          </h4>
          <p className="text-muted small mb-4">
            Ubah status keaktifan Area Manager ini
          </p>

          <Form className="text-left">
            <Form.Group>
              <label className="small fw-800 text-muted text-uppercase mb-2">
                Pilih Status Baru
              </label>
              <Select
                className="react-select primary shadow-sm"
                classNamePrefix="react-select"
                name="singleSelect"
                value={status}
                onChange={(selectedOption) => setStatus(selectedOption)}
                options={[
                  { value: "true", label: "✅ AKTIFKAN AKUN" },
                  { value: "false", label: "❌ NON-AKTIFKAN" },
                ]}
                placeholder="-- Pilih Status --"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: "12px",
                    height: "45px",
                    fontWeight: "700",
                  }),
                }}
              />
            </Form.Group>

            {/* Stacked Button: Simpan di atas, Batal di bawah */}
            <div className="mt-4">
              <Button
                className="btn-block py-3 border-0 fw-900 shadow-sm"
                style={{
                  background: "#2e3192", // Biru BPR Jatim
                  borderRadius: "12px",
                  color: "white",
                  fontSize: "14px",
                  letterSpacing: "1px",
                }}
                onClick={checkStatus}
              >
                UPDATE STATUS SEKARANG
              </Button>
              <Button
                variant="link"
                className="btn-block mt-2 text-muted fw-700 text-decoration-none small"
                onClick={() => setModalEdit(false)}
              >
                Batalkan
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalAreaManager}
        onHide={() => {
          handleModalClose();
          setModalAreaManager(false);
        }}
        centered
        contentClassName="border-0 shadow-2xl"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-5 pb-5">
          <div className="d-flex align-items-center mb-4">
            <div
              className="p-3 mr-3 shadow-sm"
              style={{
                background: "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                borderRadius: "15px",
                color: "white",
              }}
            >
              <i
                className="fas fa-user-plus fa-lg"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <div>
              <h3 className="m-0 font-weight-bold">TAMBAH AREA MANAGER</h3>
              <p className="m-0 text-muted">
                Registrasi Area Manager Baru BPR JATIM
              </p>
            </div>
          </div>

          <Form>
            <Form.Group className="mb-3">
              <label className="small fw-800 text-dark text-uppercase">
                Nomor Induk Kependudukan (NIK)
              </label>
              <div
                className="d-flex align-items-center bg-light border rounded-lg px-3 shadow-sm"
                style={{ height: "55px" }}
              >
                <Form.Control
                  className="border-0 bg-transparent fw-700 h-100"
                  onChange={handleNikChange}
                  value={nik}
                  type="text"
                  placeholder="Masukkan 16 Digit NIK"
                />
                <span
                  className={`badge ${remainingDigits === 0 ? "badge-success" : "badge-warning"} py-2 px-3`}
                >
                  {remainingDigits} Digit
                </span>
              </div>
            </Form.Group>

            <Row>
              <Col md="6">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    Nama Lengkap
                  </label>
                  <Form.Control
                    className="border-0 shadow-sm bg-light"
                    style={{
                      height: "50px",
                      borderRadius: "12px",
                      fontWeight: "600",
                    }}
                    placeholder="Contoh: Ahmad Subardjo"
                    onChange={(e) => setNama(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    No. Karyawan (Nopeg)
                  </label>
                  <Form.Control
                    className="border-0 shadow-sm bg-light"
                    style={{
                      height: "50px",
                      borderRadius: "12px",
                      fontWeight: "600",
                    }}
                    placeholder="Contoh: 2024001"
                    onChange={(e) => setNopeg(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            {auth.role === "super admin" && (
              <Form.Group className="mb-3">
                <label className="small fw-800 text-dark text-uppercase">
                  Pilih Penempatan Client / BPD
                </label>
                <Select
                  classNamePrefix="react-select"
                  value={pilihClient}
                  onChange={(v) => {
                    setPilihClient(v);
                    setIdClientAM(v.value);
                  }}
                  options={listClient}
                  placeholder="Pilih Client Penempatan"
                  styles={{
                    control: (b) => ({
                      ...b,
                      borderRadius: "12px",
                      minHeight: "50px",
                    }),
                  }}
                />
              </Form.Group>
            )}

            {/* FOOTER ACTION: STACKED */}
            <div className="mt-4 pt-2">
              <Button
                className="btn-block py-3 border-0 fw-900 shadow-lg"
                style={{
                  background:
                    "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                  borderRadius: "15px",
                  color: "white",
                  fontSize: "16px",
                }}
                onClick={submitAreaManager}
              >
                SIMPAN DATA AREA MANAGER
              </Button>
              <Button
                variant="link"
                className="btn-block mt-2 text-muted fw-700 text-decoration-none"
                onClick={() => {
                  handleModalClose();
                  setModalAreaManager(false);
                }}
              >
                Batal & Tutup
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Tab.Content>
        {/* AREA ACTION & SEARCH (STYLE BPR JATIM) */}
        <div className="px-4 py-2 bg-white">
          <Row className="align-items-center justify-content-between">
            {/* Kolom Tombol Tambah */}
            <Col md="5" xs="12" className="mb-3 mb-md-0">
              {auth.role === "super admin" || auth.role === "admin" ? (
                <Button
                  className="btn-fill btn-wd d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    marginTop: "10px",
                    background:
                      "linear-gradient(135deg, #f90203 0%, #ff4d4d 100%)",
                    fontWeight: "900",
                    border: 0,
                    borderRadius: "12px",
                    padding: "10px 25px",
                    fontSize: "13px",
                    letterSpacing: "0.5px",
                  }}
                  onClick={() => setModalAreaManager(!modalAreaManager)}
                >
                  <i className="fas fa-plus-circle mr-2"></i>
                  TAMBAH AREA MANAGER
                </Button>
              ) : null}
            </Col>

            {/* Kolom Search Bar */}
            <Col md="4" xs="12">
              <InputGroup
                className="shadow-none border rounded-lg"
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  backgroundColor: "#f8fafc",
                }}
              >
                <InputGroup.Prepend>
                  <InputGroup.Text className="bg-transparent border-0">
                    <i className="fas fa-search text-muted"></i>
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  className="border-0 bg-transparent fw-600"
                  style={{
                    paddingLeft: "5px",
                    height: "45px",
                    fontSize: "14px",
                  }}
                  type="text"
                  value={searchText}
                  onChange={handleSearch}
                  placeholder="No Karyawan / Nama AM..."
                />
              </InputGroup>
            </Col>
          </Row>
        </div>

        <hr className="mx-4 my-4" style={{ opacity: "0.05" }} />

        {/* AREA TABLE / LOADING STATE */}
        <div className="px-4 pb-4">
          {isLoading ? (
            <div
              className="loader-container d-flex flex-column align-items-center justify-content-center"
              style={{
                minHeight: "40vh",
                background: "#f8fafc",
                borderRadius: "20px",
              }}
            >
              <Dna
                visible={true}
                height="100"
                width="100"
                ariaLabel="dna-loading"
              />
              <h6
                className="mt-3 font-weight-bold text-muted"
                style={{ letterSpacing: "2px", fontSize: "12px" }}
              >
                MEMUAT DATA AREA MANAGER...
              </h6>
            </div>
          ) : (
            <div className="table-responsive rounded-xl shadow-sm border">
              <DataTable
                columns={colAreaManager}
                data={listAreaManager.filter(
                  (row) =>
                    row.nama.toLowerCase().includes(searchText.toLowerCase()) ||
                    row.nopeg.toLowerCase().includes(searchText.toLowerCase()),
                )}
                customStyles={customStyles}
                pagination
                paginationRowsPerPageOptions={[10, 25, 50, 75, 100]}
                paginationPerPage={itemsPerPage}
                onChangePage={handlePageChange}
                highlightOnHover
                pointerOnHover
              />
            </div>
          )}
        </div>

        <style>{`
    .fw-600 { font-weight: 600; }
    .rounded-xl { border-radius: 15px !important; overflow: hidden; }
    .btn-fill { transition: all 0.3s ease; }
    .btn-fill:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(249, 2, 3, 0.3) !important; }
    
    .input-group:focus-within {
      border-color: #2e3192 !important;
      box-shadow: 0 0 0 0.2rem rgba(46, 49, 146, 0.1) !important;
    }
  `}</style>
      </Tab.Content>
    </>
  );
}
export default ListAreaManager;
